export enum ProductVariationType {
  CUSTOM = 'CUSTOM',
  SIZE = 'SIZE',
  COLOR = 'COLOR',
  LANGUAGE = 'LANGUAGE',
}
